/**
 * These are MLS Mapper event data types.
 * QS receives 'import', 'cancel' and 'loaded'.
 * QS sends 'storage'
 */
export enum MlsMapperEventTypes {
    import = 'import',
    cancel = 'cancel',
    loaded = 'loaded',
    storage = 'storage'
}
